import { createFileRoute } from '@tanstack/react-router'
import { CustomerNumbersPage } from '@/features/customer/pages/numbers'

export const Route = createFileRoute('/_authenticated/customer/numbers')({
  component: CustomerNumbersPage,
})
